<form
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  name="form"
  [formGroup]="preferencesForm"
  *ngIf="preferencesForm"
  fusePerfectScrollbar
>
  <div fxLayout="column">
    <div fxLayout="row">
      <mat-slide-toggle class="mat-toggle-position" formControlName="featureOpenedMaintenanceSendEmailNotification">
        {{ 'USERS.DIALOG.PREFERENCES.ENABLE_OPENED_MAINTENANCE_EMAIL' | translate }}
      </mat-slide-toggle>
    </div>
    <small class="subtitle-text">
      {{ 'USERS.DIALOG.PREFERENCES.ENABLE_OPENED_MAINTENANCE_EMAIL_SUBTITLE' | translate }}
    </small>
  </div>
</form>
